// import STOX_LOGO from './adminstoxlogo.png';
import STOX_LOGO from "./HOUSEOFSTOX.png";

const ICONS ={
    STOX_LOGO
}

export default ICONS ;